const types = {
  VALIDATE_ZIPCODE: '@@PO_preferences/VALIDATE_ZIPCODE',
  FETCH_ZIP_CODE: '@@PO_preferences/FETCH_ZIP_CODE',
  GET_INSURANCE_LIST: '@@PO_preferences/GET_INSURANCE_LIST',
  GET_CLINICIANS_COUNT: '@@PO_preferences/GET_CLINICIANS_COUNT',
  GET_CLINICIANS_VALID: '@@PO_preferences/GET_CLINICIANS_VALID',
};

export default types;
